import slidesGeneratorFeedback from './slidesGeneratorFeedback.module'
import AIOpenEndedGrouping from './open-ended-grouping.module'
import AIWordCloudGrouping from './word-cloud-grouping.module'
import promptToSlideGenerator from './promptToSlideGenerator.module'
import docToSlideGenerator from './docToSlideGenerator.module'
import aiPromptSuggestion from './aiPromptSuggestion.module'
import aiConversation from './aiConversation.module'

export default {
  slidesGeneratorFeedback,
  AIOpenEndedGrouping,
  AIWordCloudGrouping,
  promptToSlideGenerator,
  docToSlideGenerator,
  aiPromptSuggestion,
  aiConversation,
}
